'use client'

import { useAtomValue } from 'jotai'
import { MouseEvent } from 'react'

import { userAtom } from '@/global-state'
import { useRouter } from '@/i18n-routing'
import { getGatedRedirectUrl } from '@/utils/user/gatedNavigation'

export const useGatedNavigation = () => {
	const user = useAtomValue(userAtom)
	const router = useRouter()

	return (event: MouseEvent<HTMLElement>, targetUrl: string) => {
		const redirectUrl = getGatedRedirectUrl(user, targetUrl)

		if (!redirectUrl) {
			return
		}

		event.preventDefault()
		router.push(redirectUrl)
	}
}
